import type { FC } from 'react'
import type { CardMeta } from '../dashboard/types'
import CardInfoButton from './CardInfoButton'

type CiiPanelProps = {
  ciiRatingDistribution: { a: number; b: number; c: number; d: number; e: number }
  ciiRating: string
  onViewAll: () => void
}

const meta: CardMeta = {
  description: 'Saved CII ratings from vessel particulars, not live attained CII.',
  endpoint: 'GET /v1/vessels/{id}/propulsion',
  logic: 'Only explicitly recorded A-E ratings are counted. No fleet average or trend is estimated.',
}

const CiiPanel: FC<CiiPanelProps> = ({ ciiRatingDistribution, ciiRating, onViewAll }) => (
  <div className='flex flex-col flex-1'>
    <div className='card flex-1' style={{ borderRadius: '16px' }}>
      <div className='card-body'>
        <div className='d-flex align-items-center gap-2 mb-3'>
          <h6 className='fw-bold text-dark mb-0' style={{ fontSize: '13px' }}>Recorded CII Ratings</h6>
          <span className='ms-auto d-flex align-items-center gap-2'>
            <CardInfoButton meta={meta} />
            <a href='#' className='fw-bold' style={{ fontSize: '10px' }} onClick={(e) => { e.preventDefault(); onViewAll(); }}>View all</a>
          </span>
        </div>
        <table className='table table-sm mb-3' style={{ fontSize: '10px' }}>
          <thead><tr className='text-muted'><th>Rating</th><th>Recorded Vessels</th></tr></thead>
          <tbody>
            {Object.entries(ciiRatingDistribution).map(([rating, count]) => <tr key={rating}><td>{rating.toUpperCase()}</td><td>{count}</td></tr>)}
          </tbody>
        </table>
        <div className='text-muted'>No verified 30-day fuel series is available for this dashboard.</div>
      </div>
    </div>
  </div>
)

export default CiiPanel
